import { rankingChip } from "../OverviewPage/TeamHeaderBand";
import type { TeamRankingType } from "../OverviewPage/TeamRankings/types";

/**
 * One game-flow quadrant: a rail with the quadrant's name and where it stands (the band's breakdown chip, big: a
 * game's percentile, a season's rank), then the quadrant's tables.
 */
export default function Quadrant({
  id,
  title,
  ranking,
  isSingleGame = true,
  children,
}: {
  id: string;
  title: string;
  ranking?: TeamRankingType;
  isSingleGame?: boolean;
  children: React.ReactNode;
}) {
  const chip = ranking?.rankOrPercentile != null ? rankingChip(ranking, isSingleGame) : null;
  return (
    <section className="q" data-quadrant={id}>
      <div className="rail">
        <div className="qt">{title}</div>
        {chip && (
          <span className="chip big" style={chip.style}>
            {chip.text}
          </span>
        )}
      </div>
      <div className="body">{children}</div>
    </section>
  );
}
